import { apiFetch } from './apiClient';



function fromApi(lead) {
  return {
    id:                lead.id,
    nome:              lead.nome,
    empresa:           lead.empresa            ?? '',
    cnpj:              lead.cnpj               ?? '',
    cpf:               lead.cpf                ?? '',
    telefone:          lead.telefone           ?? '',
    email:             lead.email              ?? '',
    servicosInteresse: lead.servicos_interesse ?? [],
    servicosDetalhes:  lead.servicos_detalhes  ?? [],
    anotacoes:         lead.observacoes        ?? '',
    negociacao:        lead.negociacao         ?? '',
    regimeTributario:  lead.regime_tributario  ?? '',
    anexosSimples:     lead.anexos_simples     ?? [],
    tiposAtividade:    lead.tipos_atividade    ?? [],
    porteEmpresa:      lead.porte_empresa      ?? '',
    setoresMovimento:  lead.setores_movimento  ?? {},
    obrigacoes:        lead.obrigacoes         ?? [],
    status:            lead.status,
    onboardStatus:     lead.onboard_status     ?? 'pendente',
    onboardProgresso:  lead.onboard_progresso  ?? 0,
    codigoCliente:     lead.codigo_cliente     ?? '',
    clienteCriado:     lead.cliente_criado     ?? false,
    /* fluxo novo (Leads reestruturado): abre o onboarding novo */
    tipoFluxo:         lead.tipo_fluxo         ?? '',
    dataCadastro:      lead.criado_em
      ? lead.criado_em.split('T')[0]
      : new Date().toISOString().split('T')[0],
  };
}

export async function listarConvertidos() {
  const data = await apiFetch('/onboard/leads');
  return data.map(fromApi);
}

export async function atualizarProgresso(id, progresso) {
  const data = await apiFetch(`/onboard/leads/${id}/progresso`, {
    method: 'PATCH',
    body: JSON.stringify({ progresso }),
  });
  return fromApi(data);
}
